'use client'

import { cn } from '@/lib/utils'
import Link from 'next/link'
import { useSelectedLayoutSegment } from 'next/navigation'

// This *client* component will be imported into a blog layout
export function NavLink({
  slug,
  children
}: {
  slug: string
  children: React.ReactNode
}) {
  // Navigating to `/blog/hello-world` will return 'hello-world'
  // for the selected layout segment
  const segment = useSelectedLayoutSegment()
  const isActive = slug === segment

  return (
    <Link
      href={`/help-center/${slug}`}
      // Change style depending on whether the link is active
      className={cn(
        isActive
          ? 'bg-primary/10 text-primary font-medium'
          : 'hover:bg-muted text-muted-foreground hover:text-foreground',
        'group mt-2 lg:mt-0 flex items-center -ml-4 px-4 py-1.5 rounded-lg focus:outline-primary leading-snug'
      )}
    >
      {children}
    </Link>
  )
}
